export default __webpack_public_path__ + "static/media/9-3.4ab268bc.mp3";